import cx from "classnames"
import BaseHero from "components/BaseHero"
import BackwardsNav from "components/BaseHero/BackwardsNav"
import Section, { parseColors } from "components/Section"
import moment from "moment"
import "moment/locale/de"
import { calcReadingTime } from "../../utils/calc-reading-time"
import { getColors } from "../../utils/color-combinations"
import wysiwygStyles from "../Wysiwyg/Wysiwyg.module.scss"
import styles from "./BlogHero.module.scss"

const BlogHero = ({ data }) => {
  const {
    title,
    letter,
    sub_title: subTitle,
    title_image: titleImage,
    publish_date: publishDate,
    dynamic_content: dynamicContent,
    locale,
  } = data

  const colors = getColors(data)
  const { isLightBackground } = parseColors({ colors })
  const readingTime = calcReadingTime(dynamicContent)

  const hasLatestEdit = Boolean(
    dynamicContent?.find((dc) => dc.type === "latest_edit")
  )

  const formattedPublishDate = moment(publishDate)
    .locale("de")
    .format("DD.MM.Y")

  return (
    <>
      <section className={styles.section}>
        <BackwardsNav
          locale={locale}
          isLightBackground={isLightBackground}
          url="/presse"
          text="Presse"
        />
        <BaseHero
          headline={title}
          subline={subTitle}
          image={titleImage}
          colors={colors}
          letter={letter}
          readingTime={readingTime}
          locale={locale}
          isArticle={true}
          publishDate={hasLatestEdit ? null : formattedPublishDate}
          cornersRounded={[0, 0, 1, 0]}
          isFull={true}
          showSubtexts={false}
        />
      </section>

      {locale !== "digital" && subTitle && (
        <Section noPadding={true} colors={colors}>
          <div className={cx(wysiwygStyles.wysiwyg_content, styles.subtitle)}>
            <p>{subTitle}</p>
          </div>
        </Section>
      )}
    </>
  )
}

export default BlogHero
